import { useMemo } from "react";

export function useCleanBody(body: string): string {
  return useMemo(() => {
    const temp = document.createElement("div");
    temp.innerHTML = body.replace(/<br\s*\/?>/gi, " ");
    const textOnly = temp.textContent || temp.innerText || "";
    return textOnly.replace(/\s+/g, " ").trim();
  }, [body]);
}
